import React from 'react';
import Logo from './12learn-logo.png'
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone} from '@ant-design/icons';

interface LoginData {
  email: string
  password: string
  isLoading: boolean
}

type Props = {
  onFinish: (e : any) => void
  loginData: LoginData
};

const LoginForm = (props: Props) => {
  return (
    <div style={{
        backgroundColor: '#fff',
        boxShadow: '0 0 10px 4px rgba(222,222,222,0.4)',
        padding: '20px 30px',
        marginTop: 0,
    }}>
      <img src={Logo} alt="logo"/>
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={props.onFinish}
      >
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your Email!' }]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
          >
          <Input.Password
            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" loading={props.loginData.isLoading}>
            Log in
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginForm;